<template>
    <div 
      class="px-5 pt-8 pb-5">
      <v-layout wrap>
        <v-flex>
          <section>
            
            <v-card flat class="mb-0">
              <div class="px-6 py-4">
                <div class="d-flex align-center justify-space-between w-100">
                  <div>
                    <h1 class="fs-18 font-weight-bold mb-1">Hapus Item Order</h1>
                    <p class="fs-14 text--secondary mb-0">
                      Hapus item order dari orderan
                    </p>
                  </div>
                  <div class="d-flex align-center">
                    <v-btn
                      color="primary"
                      elevation="0"
                      small
                      @click="fetchDetail"
                      :loading="process.load"
                      class="text-capitalize"
                    >
                      <v-icon left>mdi-refresh</v-icon>
                      Refresh
                    </v-btn>
                  </div>
                </div>
              </div>
            </v-card>
  
            <v-row
              class="mt-3">
              <v-col 
                cols="12"
                class="py-0">
                <v-card 
                  flat
                  style="border-radius: 8px;">
                  <v-card-text
                    v-if="process.load" 
                    class="pb-0 my-4" style="height: 500px; display: flex; align-items: center; justify-content: center;">
                    <div class="text-center">
                      <div class="mb-2 title">
                        Mohon Tunggu...
                      </div>
                      <v-progress-circular
                        indeterminate
                      ></v-progress-circular>
                    </div>
                  </v-card-text>
  
                  <v-card-text v-if="!process.load && Object.keys(detail).length > 0">
                    <v-row>
                      <v-col cols="12">
                        <div class="font-weight-bold">
                          Customers :
                        </div>
                      </v-col>
                      <v-col cols="12" md="6" class="pt-0">
                        <div>
                          <div class="fs-15 font-weight-bold">
                            {{ detail.customer_name }}
                          </div>
                          <div class="text-lowercase">
                            {{ detail.shipping_address }}, kel. {{ detail.shipping_village }}, kec. {{ detail.shipping_subdistrict }}
                            Kab. {{ detail.shipping_city }} - {{ detail.shipping_province }}
                          </div>
                        </div>
                        <table>
                          <tr>
                            <td class="">
                              Nama Toko
                            </td>
                            <td style="width: 40px" class="text-center">
                              : 
                            </td>
                            <td class="text-left font-weight-bold">
                              {{ detail.store_name }}
                            </td>
                          </tr>
                          <tr>
                            <td class="">
                              Tipe Toko
                            </td>
                            <td style="width: 40px" class="text-center">
                              :
                            </td>
                            <td class="text-left font-weight-bold">
                              {{ detail.store_type }}
                            </td>
                          </tr>
                        </table>
                      </v-col>
                      <v-col cols="12" md="6" class="d-flex justify-end pt-0">
                        <div>
                          <table style="width: 100%;">
                            <tr>
                              <td class="font-weight-bold">
                                Nomer Order
                              </td>
                              <td style="width: 80px" class="text-center">
                                : 
                              </td>
                              <td class="text-right">
                                {{ detail.number }}
                              </td>
                            </tr>
                            <tr>
                              <td class="font-weight-bold">
                                Tanggal Order
                              </td>
                              <td style="width: 80px" class="text-center">
                                :
                              </td>
                              <td class="text-right">
                                {{ detail.input_datetime | datetime }}
                              </td>
                            </tr>
                            <tr>
                              <td class="font-weight-bold">
                                Nama Sales
                              </td>
                              <td style="width: 80px" class="text-center">
                                : 
                              </td>
                              <td class="text-right">
                                {{ detail.sales_name }}
                              </td>
                            </tr>
                            <tr>
                              <td class="font-weight-bold">
                                Order By
                              </td>
                              <td style="width: 80px" class="text-center">
                                : 
                              </td>
                              <td class="text-right">
                                {{ detail.orders_by === 'sales' ? detail.sales_name : detail.orders_by === 'customer' ? detail.customer_name : detail.orders_by }} <span class="text-capitalize">( {{ detail.orders_by }} )</span>
                              </td>
                            </tr>
                          </table>
                        </div>
                      </v-col>
                      <v-col cols="12" class="my-8">
                        <div style="overflow: auto; ">
                          <table style="width: 100%;">
                            <tr>
                              <td style="height: 70px; border: 1px solid #ededed; padding: 10px;" class="font-weight-bold text-center">
                                Aksi
                              </td>
                              <td style="height: 70px; border: 1px solid #ededed; padding: 10px;" class="font-weight-bold text-center">
                                Kode Barang
                              </td>
                              <td style="height: 70px; border: 1px solid #ededed; padding: 10px;" class="font-weight-bold text-center">
                                Nama Barang
                              </td>
                              <td style="height: 70px; border: 1px solid #ededed; padding: 10px;" class="font-weight-bold text-center">
                                Quantity
                              </td>
                              <td style="height: 70px; border: 1px solid #ededed; padding: 10px;" class="font-weight-bold text-center">
                                Harga Per Unit
                              </td>
                              <td style="height: 70px; border: 1px solid #ededed; padding: 10px;" class="font-weight-bold text-center">
                                Harga Bruto
                              </td>
                              <td style="height: 70px; border: 1px solid #ededed; padding: 10px;" class="font-weight-bold text-center">
                                Diskon Promo
                              </td>
                              <td style="height: 70px; border: 1px solid #ededed; padding: 10px;" class="font-weight-bold text-center">
                                Diskon Strata
                              </td>
                              <td style="height: 70px; border: 1px solid #ededed; padding: 10px;" class="font-weight-bold text-center">
                                Harga Net. 
                              </td>
                            </tr>
                            <tr v-for="(item, index) in detail.detail" :key="index">
                              <td style="border: 1px solid #ededed; padding: 10px;" class="">
                                <v-checkbox
                                  v-model="item.is_checked"
                                  class="mt-0"
                                  hide-details
                                  @change="recalculateTotals"
                                ></v-checkbox>
                              </td>
                              <td style="border: 1px solid #ededed; padding: 10px;" class="">
                                {{ item.detail_varian_sku }}
                              </td>
                              <td style="border: 1px solid #ededed; padding: 10px;" class="">
                                {{ item.detail_varian_name }}
                              </td>
                              <td style="border: 1px solid #ededed; padding: 10px;" class="">
                                {{ `${(item.detail_total_in_dus*1) === 1 ? 0 : item.detail_qty_dus}.${item.detail_qty_lusin}.${(item.detail_total_in_dus*1) === 1 ? item.detail_qty_dus : item.detail_qty_pcs}` }}
                              </td>
                              <td style="border: 1px solid #ededed; padding: 10px;" class="text-right">
                                <!-- Rp {{ item.detail_qty_pcs !== 0 ? item.detail_price_pcs : item.detail_qty_lusin !== 0 ? item.detail_price_lusin : item.detail_price_dus }} -->
                                <span v-if="item.detail_qty_pcs !== 0">
                                  {{ item.detail_price_per_pcs | number_dec }}
                                </span>
                                <span v-else-if="item.detail_qty_lusin !== 0">
                                  {{ (item.detail_price_per_pcs*12) | number_dec }}
                                </span>
                                <span v-else-if="item.detail_qty_dus !== 0">
                                  {{ Math.round(item.detail_price_per_pcs*item.detail_total_in_dus) | number_dec }}
                                </span>
                              </td>
                              <td style="border: 1px solid #ededed; padding: 10px;" class="text-right">
                                <!-- <span v-if="item.detail_qty_pcs !== 0">{{ item.detail_price_pcs | price }}</span>
                                <span v-else-if="item.detail_qty_lusin !== 0">{{ item.detail_price_lusin | price }}</span>
                                <span v-else-if="item.detail_qty_dus !== 0">{{ item.detail_price_dus | price }}</span> -->
                                {{ (item.detail_price_dus*1) + (item.detail_price_lusin*1) + (item.detail_price_pcs*1) | price }}
                              </td>
                              <td style="border: 1px solid #ededed; padding: 10px;" class="text-center">
                                {{ (((item.detail_discount*1))) | price }}
                              </td>
                              <td style="border: 1px solid #ededed; padding: 10px;" class="text-center">
                                {{ (((item.detail_strata_nominal*1)*(item.detail_qty_dus))) | price }}
                              </td>
                              <td style="border: 1px solid #ededed; padding: 10px;" class="text-right">
                                {{ (((item.detail_price_dus*1) + (item.detail_price_lusin*1) + (item.detail_price_pcs*1)) - ((((item.detail_discount*1)) + ((item.detail_strata_nominal*1)*(item.detail_qty_dus))))) | price }}
                              </td>
                            </tr>
                          </table>
                        </div>
                      </v-col>
                      <v-col cols="12" md="6">
                        <div>
                          Total Qty: <span>{{ totalQty }}.0.0</span>, Total Item: {{ totalCheckedItems }}
                        </div>
                      </v-col>
                      <v-col cols="12" md="6" class="d-flex justify-end pt-0">
                        <div class="fs-15">
                          <table style="width: 100%;">
                            <tr>
                              <td class="pa-2 font-weight-bold">
                                Harga Bruto
                              </td>
                              <td style="width: 80px" class="pa-2 text-center">
                                : 
                              </td>
                              <td class="pa-2 text-right">
                                {{ totalBruto | price }}
                              </td>
                            </tr>
                            <tr>
                              <td class="pa-2 font-weight-bold">
                                Diskon 
                              </td>
                              <td style="width: 80px" class="pa-2 text-center">
                                :
                              </td>
                              <td class="pa-2 text-right">
                                <!-- {{ detail.total_discount*1 | price }} -->
                                  {{ totalDiskon | price }}
                              </td>
                            </tr>
                            <!-- <tr>
                              <td class="pa-2 font-weight-bold">
                                PPN 11%
                              </td>
                              <td style="width: 80px" class="pa-2 text-center">
                                : 
                              </td>
                              <td class="pa-2 text-right">
                                {{ detail.sales_name }}
                              </td>
                            </tr> -->
                            <tr>
                              <td class="pa-2 font-weight-bold">
                                Harga Net
                              </td>
                              <td style="width: 80px" class="pa-2 text-center">
                                :
                              </td>
                              <td class="pa-2 text-right">
                                {{ totalNet | price }}
                              </td>
                            </tr>
  
                          </table>
                        </div>
                      </v-col>
                      <!-- <v-col>
                        <div>
                          <div class="mb-1 input-label">
                            Nomer Order
                          </div>
                          <div class="fs-18 font-weight-bold">
                            {{ detail.number }}
                          </div>
                        </div>
                      </v-col>
                      <v-col>
                        <div>
                          <div class="mb-1 input-label">
                            Nama Sales
                          </div>
                          <div class="fs-18 font-weight-bold">
                            {{ detail.sales_name }}
                          </div>
                        </div>
                      </v-col>
  
                      <v-col>
                        <div>
                          <div class="mb-1 input-label">
                            Nama Customer
                          </div>
                          <div class="fs-18 font-weight-bold">
                            {{ detail.customer_name }}
                          </div>
                        </div>
                      </v-col>
  
                      <v-col>
                        <div>
                          <div class="mb-1 input-label">
                            Tanggal Order
                          </div>
                          <div class="fs-18 font-weight-bold">
                            {{ detail.input_datetime | date }}
                          </div>
                        </div>
                      </v-col> -->
                    </v-row>
  
                    <!-- <v-row>
                      <v-col>
                        <div class="mb-2">
                          <div class="mb-1 input-label">
                            Alamat
                          </div>
                          <div class="fs-16 font-weight-bold">
                            {{ detail.shipping_address }}
                          </div>
                        </div>
                      </v-col>
                      <v-col>
  
                        <div class="mb-2">
                          <div class="mb-1 input-label">
                            Kelurahan
                          </div>
                          <div class="fs-16 font-weight-bold">
                            {{ detail.shipping_village }}
                          </div>
                        </div>
  
                        <div class="mb-2">
                          <div class="mb-1 input-label">
                            Kecamatan
                          </div>
                          <div class="fs-16 font-weight-bold">
                            {{ detail.shipping_subdistrict }}
                          </div>
                        </div>
                        </v-col>
                        <v-col>
  
                        <div class="mb-2">
                          <div class="mb-1 input-label">
                            Kabupaten
                          </div>
                          <div class="fs-16 font-weight-bold">
                            {{ detail.shipping_city }}
                          </div>
                        </div>
  
                        <div class="mb-2">
                          <div class="mb-1 input-label">
                            Provinsi
                          </div>
                          <div class="fs-16 font-weight-bold">
                            {{ detail.shipping_province }}
                          </div>
                        </div>
  
                      </v-col>
                      <v-col></v-col>
                    </v-row> -->
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
          </section>
        </v-flex>
      </v-layout>
    </div>
  </template>
  
  <script>
    import { get, post, put, patch, destroy } from "@/service/Axios";
  // import { filter } from "core-js/core/array";
    import moment from "moment"
    import "moment/locale/id"
    export default {
      data () {
        return {
          approved_by: [],
          approved_reason: '',
          date: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
          menu: false,
          modal: false,
          menu2: false,
          
          zoomed: false,
          zoomedTtd: false,
          imageAspectRatio: 1,
          imageAspectRatioTtd: 1,
  
          dialog: {
            status: false,
            komfirmasi: false,
            bukti: false
          },
  
          detail: {},
  
          rejected_reason: '',
          invoice: [],
  
          form: {
            id: '',
            sales_id: '',
            name_alias: '',
            name: '',
            mobilephone_arr: [],
            email: '',
            nik: '',
            npwp: '',
            plafon: '',
            faktur: '',
            term: '',
            ttd: ''
          },
          selected: {
            detail: [],
            is_titip: []
          },
          category: [],
          branch: [],
          
  
          mobilephone: {
            name: '',
            id: ''
          },
  
          upload: {
            ttd: null,
            image_url: null
          },
  
          process: {
            form: false,
  
            load: false,
  
            image_url: false,
            invoice: false
          },

          totalBruto: 0,
          totalDiskon: 0,
          totalNet: 0,
          totalQty: 0,
          totalCheckedItems: 0,
          
          message: {
            success: '',
            error: '',
            status: ''
          }
        }
      },
      components: {
        uploadfolder: () => import(/* webpackPrefetchCategory: true */ '@/components/upload/folder.vue')
      },
      watch: {
        // Watch tidak diperlukan karena computed properties sudah reactive
      },
      computed: {
        user () {
          return this.$store.state.user
        },
        rps () {
          return this.$vuetify.breakpoint.name
        },
        fcm () {
          return this.$store.state.fcm
        },
        isDay () {
          let hours = (new Date()).getHours(),
              day = hours >= 5 && hours <= 8 ? 'pagi' : hours > 8 && hours <= 14 ? 'siang' : hours > 14 && hours <= 18 ? 'sore' : 'malam'
          return day
        },
        set_color () {
          return this.$store.state.color
        },
        set_color_rgb () {
          let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))
  
          return `rgba(${r}, ${g}, ${b}, 0.97)`
        },
        set_color_rgb_up () {
          let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))
  
          return `rgba(${r}, ${g+30}, ${b+30}, 0.97)`
        },
        set_color_rgb_down () {
          let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))
  
          return `rgba(${r}, ${g}, ${b}, 0.25)`
        },
      },
      mounted () {
        this.fetchDetail()
      },
      methods: {
        recalculateTotals () {
          // Method ini akan dipanggil setiap kali checkbox berubah
          // Computed properties akan otomatis menghitung ulang
          this.totalBruto = 0
          this.totalDiskon = 0
          this.totalNet = 0
          this.totalQty = 0
          this.totalCheckedItems = 0

          this.detail.detail.forEach(item => { 
            if (item.is_checked) {
              this.totalBruto += item.detail_price_dus*1 + item.detail_price_lusin*1 + item.detail_price_pcs*1
              this.totalDiskon += item.detail_discount*1 + item.detail_strata_nominal*1*item.detail_qty_dus
              this.totalNet += item.detail_price_dus*1 + item.detail_price_lusin*1 + item.detail_price_pcs*1 - item.detail_discount*1 - item.detail_strata_nominal*1*item.detail_qty_dus
              this.totalQty += item.detail_qty_dus*1 + item.detail_qty_lusin*1 + item.detail_qty_pcs*1
              this.totalCheckedItems += 1
            }
          })

          console.log('totalBruto', this.totalBruto)
          console.log('totalDiskon', this.totalDiskon)
          console.log('totalNet', this.totalNet)
        },
        async fetchDetail () {
          this.process.load = true
          let params = {
            id: this.$route.params.id
          }
  
          await get('admin/order/detail', { params })
          .then(response => {
            let res = response.data
              
            if (res.status === 200) {
              this.detail = res.results.data

              this.detail.detail.forEach(item => {
                item.is_checked = true
              })
              // this.detail.approved_by = 'supervisor'
              // this.detail.order_approval.Supervisor = [{
              //   datetime: new Date(),
              //   user_name: 'test'
              // }]
              // this.detail.order_approval.Sales_Manager = [{
              //   datetime: new Date(),
              // }]
              // this.detail.order_approval.Finance_Manager = [{
              //   datetime: new Date(),
              // }]
              this.detail.approved_reason = this.detail.approved_reason.length < 1 ? { name: '', reason: '' } : JSON.parse(this.detail.approved_reason)

              this.recalculateTotals()
            }
            this.process.load = false
          })
        },
      }
    }
  </script>
  
  
  <style>
    /* ::-webkit-scrollbar {
      width: 10px;
      height: 10px;
      background-color: #F5F5F5;
    }
    ::-webkit-scrollbar-track{
      background-color: #F5F5F5;
      border-radius: 10px;
    } */
    ::-webkit-scrollbar-thumb{
      border-radius: 10px;
      background-color: #718EBF;
    }
    table, th, td {
      /* border: 1px solid #ededed;
      border-collapse: collapse; */
      /* border: thin ridge black; */
      border-spacing: 4px;
      border-collapse: collapse;
    }
  
    .view {
      margin: auto;
      /* width: 100%; */
    }
  
    .wrapper-detail-order { 
      overflow-y: auto; 
      height: 100% 
    } 
  
    .wrapper-detail-order-none { 
      /* overflow-y: auto; 
      height: calc(100vh - 270px);  */
    } 
  
    .wrapper-detail-order th { 
      position: sticky; 
      top: 0; 
      background-color: white !important;
    } 
    .sticky-col {
      position: -webkit-sticky;
      position: sticky;
      background-color: white !important;
    }
  
    .one-col {
      width: 60px;
      min-width: 60px;
      max-width: 60px;
      left: 0px;
    }
  
    .second-col {
      width: 150px;
      min-width: 150px;
      max-width: 150px;
      left: 150px;
    }
  
    .three-col {
      width: 150px;
      min-width: 150px;
      max-width: 150px;
      left: 300px;
    }
  
    .four-col {
      width: 200px;
      min-width: 200px;
      max-width: 200px;
      left: 450px;
    }
  
    tr:hover {background-color: #1976d236;}
    tr.selected {background-color: #1976d236;}
  
    .border-radius-card-8 {
      border-radius: 8px;
    }
  </style>